export default "__VITE_ASSET__fecd296e__"